// eslint-disable-next-line no-shadow
export enum PromptsStatus {
	REVIEW = 'review',
	ACTIVE = 'active',
	ARCHIVE = 'archive',
	REJECTED = 'rejected',
	UNKNOWN = 'unknown', // List prompt data where status is added on client side
}
